import { computeTrend } from "../utils";
import { CONFIG } from "./CONFIG";

// Assemble the per-signal spine. Driven off the FULL signal set (so signals
// with no topic co-occurrence still appear), enriched with: standalone total
// (tagCounts), previous-period total + trend, and the top co-occurring topics
// (from the pinned tagA→tagB pairs). Only signals that occurred this window
// (total > 0) are kept.
export const assembleSignals = (signalList, cooccurrence, prevTagCounts = {}) => {
  const tagCounts = cooccurrence?.tagCounts || {};

  // Top topics per signal, from the pinned pairs (signal = tagA).
  const topicsBySignal = {};
  for (const p of cooccurrence?.data || []) {
    const id = p.tagA?._id;
    if (!id) continue;
    (topicsBySignal[id] ||= []).push({ topic: p.tagB.display, topicId: p.tagB._id, count: p.count });
  }

  return signalList
    .map((sig) => {
      const id = sig._id;
      const total = tagCounts[id] ?? 0;
      const prevTotal = prevTagCounts[id] ?? 0;
      return {
        signal: sig.display,
        signalId: id,
        category: sig.category,
        total,
        prevTotal,
        ...computeTrend(total, prevTotal, CONFIG.trendThresholdPct),
        topics: (topicsBySignal[id] || []).sort((a, b) => b.count - a.count).slice(0, CONFIG.topCooccurringTopics),
      };
    })
    .filter((s) => s.total > 0)
    .sort((a, b) => b.total - a.total);
};

// Narrow the raw time series (all annotation tags per bucket) to signal tags.
// Keeps the `dimensions` key so it feeds TrendLineChart / the shared LineChart directly.
export const narrowToSignals = (series, signalList) => {
  const idSet = new Set((signalList || []).map((s) => String(s._id)));
  return (series || []).map((b) => ({
    timeInterval: b.timeInterval,
    dimensions: (b.dimensions || []).filter((d) => idSet.has(String(d.value))),
  }));
};
